import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_RETAILER_PERFORMANCE_API = "GET_RETAILER_PERFORMANCE_API";
export const GET_RETAILER_PERFORMANCE_API_SUCCESS = "GET_RETAILER_PERFORMANCE_API_SUCCESS";
export const GET_RETAILER_PERFORMANCE_API_FAILED = "GET_RETAILER_PERFORMANCE_API_FAILED";

export const GET_MNP_ACTIVATION_API = "GET_MNP_ACTIVATION_API";
export const GET_MNP_ACTIVATION_API_SUCCESS = "GET_MNP_ACTIVATION_API_SUCCESS";
export const GET_MNP_ACTIVATION_API_FAILED = "GET_MNP_ACTIVATION_API_FAILED";

export const GET_ATP_FSE_API = "GET_ATP_FSE_API";
export const GET_ATP_FSE_API_SUCCESS = "GET_ATP_FSE_API_SUCCESS";
export const GET_ATP_FSE_API_FAILED = "GET_ATP_FSE_API_FAILED";

export const GET_ATP_OUTER_API = "GET_ATP_OUTER_API";
export const GET_ATP_OUTER_API_SUCCESS = "GET_ATP_OUTER_API_SUCCESS";
export const GET_ATP_OUTER_API_FAILED = "GET_ATP_OUTER_API_FAILED";

export const GET_ATP_INNER_API = "GET_ATP_INNER_API";
export const GET_ATP_INNER_API_SUCCESS = "GET_ATP_INNER_API_SUCCESS";
export const GET_ATP_INNER_API_FAILED = "GET_ATP_INNER_API_FAILED";



export function triggerRetailerPerformanceAPI(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}top20RetailerPerformance`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_RETAILER_PERFORMANCE_API,
      successAction: GET_RETAILER_PERFORMANCE_API_SUCCESS,
      failedAction: GET_RETAILER_PERFORMANCE_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
    };
    makeAPICall(params);
  };
}

export function triggerMnpActivationAPI(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}mnp-top20-retailerPerformance`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_MNP_ACTIVATION_API,
      successAction: GET_MNP_ACTIVATION_API_SUCCESS,
      failedAction: GET_MNP_ACTIVATION_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
    };
    makeAPICall(params);
  };
}

export function triggerAtpFseAPI(obj){
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}atp-fse-filter`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_ATP_FSE_API,
      successAction: GET_ATP_FSE_API_SUCCESS,
      failedAction: GET_ATP_FSE_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
    };
    makeAPICall(params);
  };
}


export function triggerATPOuterAPI(obj){
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}atp-data-dashboard`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_ATP_OUTER_API,
      successAction: GET_ATP_OUTER_API_SUCCESS,
      failedAction: GET_ATP_OUTER_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
    };
    makeAPICall(params);
  }
}

export function triggerATPInnerAPI(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}atp-data-inner-dashboard`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_ATP_INNER_API,
      successAction: GET_ATP_INNER_API_SUCCESS,
      failedAction: GET_ATP_INNER_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
    };
    makeAPICall(params);
  }
}

